/**
 * @file 関数：HubSpot関数
 */

/**
 * グローバル変数_hsqに追加
 */
window._hsq = window._hsq || [];
window._hsq.push([
    "identify",
    {
        email: window.dataUser.userEmail,
    },
]);

/**
 * Hubspotへイベントを送信
 * @param payload {Object} ペイロード
 */
export const fnSendEventHubspot = (payload: EventDetail) => {
    const videoId = decodeURIComponent(
        location.pathname.split("/").slice(-1)[0]
    );
    window._hsq.push([
        "trackCustomBehavioralEvent",
        {
            name: payload.name,
            properties: {
                video_id: videoId,
                ...payload.properties,
            },
        },
    ]);
};
